import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { InputBase } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  wrapper: {
    fontFamily: "Open sans",
    boxSizing: "border-box",
    border: `1px solid ${theme.palette.primary[200]}`,
    background: theme.palette.primary[100],
    height: 32,
    borderRadius: 2,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: 280
  },
  prefix: {
    lineHeight: "32px",
    height: 32,
    fontSize: 14,
    color: "#999",
    display: "inline-block",
    paddingLeft: "8px",
    width: "initial"
  },
  suffix: {
    lineHeight: "32px",
    height: 32,
    fontSize: 14,
    color: "#999",
    display: "inline-block",
    paddingRight: "8px",
    width: "initial"
  },
  root: {
    padding: "0px 8px",
    fontSize: 14,
    height: 32,
    flexGrow: 1
  }
}));

function SortCodeInput({ value, onChange, prefix, suffix, disabled, ...rest }) {
  const classes = useStyles();

  function handleOnChange(e) {
    if (/^[0-9]{1,6}$/.test(e.target.value)) {
      if (onChange) {
        onChange(e.target.value);
      }
    }
  }

  return (
    <div className={classes.wrapper}>
      {prefix && <div className={classes.prefix}>{prefix}</div>}
      <InputBase
        value={value}
        onChange={onChange}
        classes={{ root: classes.root }}
        disabled={disabled}
        {...rest}
      />
      {suffix && <div className={classes.suffix}>{suffix}</div>}
    </div>
  );
}

export default SortCodeInput;
